import css from "./style.module.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie"; // Импортируем js-cookie
// import axios from "axios"; // Если потребуется, можете включить обратно
import { useAuth } from "../../auth";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { loginAsAdmin } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        const userRole = data.role;
        // console.log(response.headers.getSetCookie());
        // Сохраняем сессию в cookies
        const session = data.session;
        Cookies.set("session", session, { expires: 1 });
        Cookies.set("login", username, { expires: 1 });

        loginAsAdmin();
        navigate(userRole ? "/adminMain" : "/");
      } else {
        setError(data.message);

        if (data.message === "Не зарегистрированный пользователь") {
          setError(data.message);
          navigate("/");
        }
      }
    } catch (err) {
      console.error(err);
      setError("Ошибка при входе.");
    }
  };

  return (
    <main className={css.root}>
      <div className="container">
        <div className={css.login_form_container}>
          <form onSubmit={handleSubmit} className={css.login_form}>
            <h2>Введите логин и пароль</h2>
            <h3>Для входа в админ панель</h3>
            {error && (
              <p style={{ color: "red" }}>
                <b>Неправильный логин или пароль</b>
              </p>
            )}
            <div className={css["login_form_container"]}>
              <div className={css["login_form_item"]}>
                <label>Логин:</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              <div className={css["login_form_item"]}>
                <label>Пароль:</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            <button type="submit">Войти</button>
          </form>
        </div>
      </div>
    </main>
  );
};

export default Login;
